import { useSelector } from 'react-redux'

import { translate } from '@/utils/translations'

const TermsOfPurchaseLink = () => {
  const termsOfPurchaseLinkUrl = useSelector(
    state => state.currentRegion.termsOfPurchaseLinkUrl
  )

  return (
    <a
      className='underline'
      href={termsOfPurchaseLinkUrl}
      rel='noreferrer noopener'
      target='_blank'
    >
      {translate('carts.terms_of_purchase')}
    </a>
  )
}

export default TermsOfPurchaseLink
